export const orderItemColors = [
	{
		bg: 'rgba(255, 255, 255, 0.05)',
		border: 'rgba(255, 255, 255, 0.1)',
		dec: 'transparent',
		color: '#FFFFFF',
	},
	{
		bg: 'rgba(45, 112, 218, 0.25)',
		border: 'rgba(45, 112, 218, 0.50)',
		dec: 'rgba(45, 112, 218, 0.25)',
		color: '#2D70DA',
	},
	{
		bg: 'rgba(153, 72, 255, 0.25)',
		border: 'rgba(153, 72, 255, 0.50)',
		dec: 'rgba(153, 72, 255, 0.25)',
		color: '#9948FF',
	},
	{
		bg: 'rgba(250, 190, 44, 0.25)',
		border: 'rgba(250, 190, 44, 0.50)',
		dec: 'rgba(250, 190, 44, 0.25)',
		color: '#FABE2C',
	},
	{
		bg: 'rgba(235, 24, 24, 0.25)',
		border: 'rgba(235, 24, 24, 0.50)',
		dec: 'rgba(235, 24, 24, 0.25)',
		color: '#EB1818',
	},
];
